export default __webpack_public_path__ + "static/media/caoutchouc.b45c27be.jpg";